/**
 * @fileoverview Mock API Handlers - 金牌重量列表
 *
 * Mock 的 API Endpoints:
 *
 * 1. GET /gold/weight-list
 *    功能: 獲取金牌重量列表（按製作方式 A-J 分類）
 *
 *    Response:
 *    ```json
 *    {
 *      "result": "success",
 *      "data": {
 *        "A": [ ... ],
 *        "B": [ ... ],
 *        "C": [ ... ],
 *        "D": [ ... ],
 *        "E": [ ... ],
 *        "F": [ ... ],
 *        "H": [... ],
 *        "G": [ ...],
 *        "I": [... ],
 *        "J": [... ]
 *      }
 *    }
 *    ```
 *
 *    每個重量配置項包含:
 *    - id: 唯一標識
 *    - way: 製作方式代碼 (A-J)
 *    - cm_length: 公分長度
 *    - tin_length: 台寸長度
 *    - min_weight: 最小重量
 *    - max_weight: 最大重量
 *    - cost: 成本
 *    - fee: 費用
 *    - peer_fee: 特約會員費用
 *    - created_at: 創建時間
 *    - updated_at: 更新時間
 */

import { rest } from "msw";

const API_BASE_URL = process.env.VUE_APP_API_URL;

const weightListData = {
  A: [
    {
      id: 1,
      way: "A",
      cm_length: "6.0",
      tin_length: "2.0",
      min_weight: "0.10",
      max_weight: "30.00",
      cost: 601,
      fee: 1500,
      peer_fee: 950,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 2,
      way: "A",
      cm_length: "9.0",
      tin_length: "3.0",
      min_weight: "0.51",
      max_weight: "30.00",
      cost: 800,
      fee: 1800,
      peer_fee: 1200,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 3,
      way: "A",
      cm_length: "12.0",
      tin_length: "4.0",
      min_weight: "1.01",
      max_weight: "40.00",
      cost: 1100,
      fee: 2100,
      peer_fee: 1550,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 4,
      way: "A",
      cm_length: "15.0",
      tin_length: "5.0",
      min_weight: "2.01",
      max_weight: "50.00",
      cost: 1500,
      fee: 2600,
      peer_fee: 1950,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 5,
      way: "A",
      cm_length: "18.0",
      tin_length: "6.0",
      min_weight: "3.01",
      max_weight: "60.00",
      cost: 2000,
      fee: 3200,
      peer_fee: 2500,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 6,
      way: "A",
      cm_length: "21.0",
      tin_length: "7.0",
      min_weight: "5.01",
      max_weight: "100.00",
      cost: 2500,
      fee: 3800,
      peer_fee: 3000,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 7,
      way: "A",
      cm_length: "24.0",
      tin_length: "8.0",
      min_weight: "7.01",
      max_weight: "100.00",
      cost: 3000,
      fee: 4900,
      peer_fee: 3700,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 8,
      way: "A",
      cm_length: "27.0",
      tin_length: "9.0",
      min_weight: "12.01",
      max_weight: "120.00",
      cost: 3500,
      fee: 7500,
      peer_fee: 5000,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 9,
      way: "A",
      cm_length: "30.0",
      tin_length: "10.0",
      min_weight: "15.01",
      max_weight: "150.00",
      cost: 4500,
      fee: 9500,
      peer_fee: 7000,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 10,
      way: "A",
      cm_length: "33.0",
      tin_length: "11.0",
      min_weight: "18.01",
      max_weight: "200.00",
      cost: 4500,
      fee: 10500,
      peer_fee: 8000,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
    {
      id: 11,
      way: "A",
      cm_length: "36.0",
      tin_length: "12.0",
      min_weight: "20.01",
      max_weight: "300.00",
      cost: 5000,
      fee: 13500,
      peer_fee: 9000,
      created_at: null,
      updated_at: "2025-12-06 16:19:18",
    },
  ],
  B: [
    {
      id: 12,
      way: "B",
      cm_length: "6.0",
      tin_length: "2.0",
      min_weight: "0.30",
      max_weight: "30.00",
      cost: 800,
      fee: 1900,
      peer_fee: 1300,
      created_at: null,
      updated_at: null,
    },
    {
      id: 13,
      way: "B",
      cm_length: "9.0",
      tin_length: "3.0",
      min_weight: "0.51",
      max_weight: "30.00",
      cost: 1500,
      fee: 2850,
      peer_fee: 2000,
      created_at: null,
      updated_at: null,
    },
    {
      id: 14,
      way: "B",
      cm_length: "12.0",
      tin_length: "4.0",
      min_weight: "1.01",
      max_weight: "40.00",
      cost: 2000,
      fee: 3550,
      peer_fee: 2700,
      created_at: null,
      updated_at: null,
    },
    {
      id: 15,
      way: "B",
      cm_length: "15.0",
      tin_length: "5.0",
      min_weight: "2.01",
      max_weight: "50.00",
      cost: 2600,
      fee: 4000,
      peer_fee: 3300,
      created_at: null,
      updated_at: null,
    },
    {
      id: 16,
      way: "B",
      cm_length: "18.0",
      tin_length: "6.0",
      min_weight: "3.01",
      max_weight: "60.00",
      cost: 3500,
      fee: 6300,
      peer_fee: 4550,
      created_at: null,
      updated_at: null,
    },
    {
      id: 17,
      way: "B",
      cm_length: "21.0",
      tin_length: "7.0",
      min_weight: "5.01",
      max_weight: "100.00",
      cost: 4700,
      fee: 8400,
      peer_fee: 6550,
      created_at: null,
      updated_at: null,
    },
    {
      id: 18,
      way: "B",
      cm_length: "24.0",
      tin_length: "8.0",
      min_weight: "7.01",
      max_weight: "100.00",
      cost: 5500,
      fee: 10500,
      peer_fee: 8050,
      created_at: null,
      updated_at: null,
    },
    {
      id: 19,
      way: "B",
      cm_length: "27.0",
      tin_length: "9.0",
      min_weight: "12.01",
      max_weight: "120.00",
      cost: 7500,
      fee: 12100,
      peer_fee: 9550,
      created_at: null,
      updated_at: null,
    },
    {
      id: 20,
      way: "B",
      cm_length: "30.0",
      tin_length: "10.0",
      min_weight: "15.01",
      max_weight: "150.00",
      cost: 10000,
      fee: 16100,
      peer_fee: 13550,
      created_at: null,
      updated_at: null,
    },
    {
      id: 21,
      way: "B",
      cm_length: "33.0",
      tin_length: "11.0",
      min_weight: "18.01",
      max_weight: "200.00",
      cost: 11000,
      fee: 18200,
      peer_fee: 15550,
      created_at: null,
      updated_at: null,
    },
    {
      id: 22,
      way: "B",
      cm_length: "36.0",
      tin_length: "12.0",
      min_weight: "20.01",
      max_weight: "300.00",
      cost: 12000,
      fee: 20600,
      peer_fee: 17550,
      created_at: null,
      updated_at: null,
    },
  ],
  C: [
    {
      id: 23,
      way: "C",
      cm_length: "6.0",
      tin_length: "2.0",
      min_weight: "0.30",
      max_weight: "30.00",
      cost: 800,
      fee: 1850,
      peer_fee: 1350,
      created_at: null,
      updated_at: null,
    },
    {
      id: 24,
      way: "C",
      cm_length: "9.0",
      tin_length: "3.0",
      min_weight: "0.51",
      max_weight: "30.00",
      cost: 1500,
      fee: 2800,
      peer_fee: 2050,
      created_at: null,
      updated_at: null,
    },
    {
      id: 25,
      way: "C",
      cm_length: "12.0",
      tin_length: "4.0",
      min_weight: "1.01",
      max_weight: "40.00",
      cost: 2000,
      fee: 3550,
      peer_fee: 2700,
      created_at: null,
      updated_at: null,
    },
    {
      id: 26,
      way: "C",
      cm_length: "15.0",
      tin_length: "5.0",
      min_weight: "2.01",
      max_weight: "50.00",
      cost: 2600,
      fee: 4100,
      peer_fee: 3350,
      created_at: null,
      updated_at: null,
    },
    {
      id: 27,
      way: "C",
      cm_length: "18.0",
      tin_length: "6.0",
      min_weight: "3.01",
      max_weight: "60.00",
      cost: 3500,
      fee: 6300,
      peer_fee: 4200,
      created_at: null,
      updated_at: null,
    },
    {
      id: 28,
      way: "C",
      cm_length: "21.0",
      tin_length: "7.0",
      min_weight: "5.01",
      max_weight: "100.00",
      cost: 4700,
      fee: 8400,
      peer_fee: 6000,
      created_at: null,
      updated_at: null,
    },
    {
      id: 29,
      way: "C",
      cm_length: "24.0",
      tin_length: "8.0",
      min_weight: "7.01",
      max_weight: "100.00",
      cost: 5500,
      fee: 10500,
      peer_fee: 8000,
      created_at: null,
      updated_at: null,
    },
    {
      id: 30,
      way: "C",
      cm_length: "27.0",
      tin_length: "9.0",
      min_weight: "12.01",
      max_weight: "120.00",
      cost: 7500,
      fee: 13000,
      peer_fee: 9500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 31,
      way: "C",
      cm_length: "30.0",
      tin_length: "10.0",
      min_weight: "15.01",
      max_weight: "150.00",
      cost: 10000,
      fee: 16100,
      peer_fee: 13500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 32,
      way: "C",
      cm_length: "33.0",
      tin_length: "11.0",
      min_weight: "18.01",
      max_weight: "200.00",
      cost: 11000,
      fee: 18200,
      peer_fee: 15500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 33,
      way: "C",
      cm_length: "36.0",
      tin_length: "12.0",
      min_weight: "20.01",
      max_weight: "300.00",
      cost: 12000,
      fee: 20800,
      peer_fee: 17500,
      created_at: null,
      updated_at: null,
    },
  ],
  D: [
    {
      id: 34,
      way: "D",
      cm_length: "6.0",
      tin_length: "2.0",
      min_weight: "0.30",
      max_weight: "30.00",
      cost: 800,
      fee: 2300,
      peer_fee: 1500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 35,
      way: "D",
      cm_length: "9.0",
      tin_length: "3.0",
      min_weight: "0.51",
      max_weight: "30.00",
      cost: 1500,
      fee: 3150,
      peer_fee: 2200,
      created_at: null,
      updated_at: null,
    },
    {
      id: 36,
      way: "D",
      cm_length: "12.0",
      tin_length: "4.0",
      min_weight: "1.01",
      max_weight: "40.00",
      cost: 2000,
      fee: 3900,
      peer_fee: 2900,
      created_at: null,
      updated_at: null,
    },
    {
      id: 37,
      way: "D",
      cm_length: "15.0",
      tin_length: "5.0",
      min_weight: "2.01",
      max_weight: "50.00",
      cost: 2600,
      fee: 4350,
      peer_fee: 3500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 38,
      way: "D",
      cm_length: "18.0",
      tin_length: "6.0",
      min_weight: "3.01",
      max_weight: "60.00",
      cost: 3500,
      fee: 6700,
      peer_fee: 4800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 39,
      way: "D",
      cm_length: "21.0",
      tin_length: "7.0",
      min_weight: "5.01",
      max_weight: "100.00",
      cost: 4700,
      fee: 8800,
      peer_fee: 6800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 40,
      way: "D",
      cm_length: "24.0",
      tin_length: "8.0",
      min_weight: "7.01",
      max_weight: "100.00",
      cost: 5500,
      fee: 11000,
      peer_fee: 8300,
      created_at: null,
      updated_at: null,
    },
    {
      id: 41,
      way: "D",
      cm_length: "27.0",
      tin_length: "9.0",
      min_weight: "12.01",
      max_weight: "120.00",
      cost: 7500,
      fee: 12700,
      peer_fee: 9900,
      created_at: null,
      updated_at: null,
    },
    {
      id: 42,
      way: "D",
      cm_length: "30.0",
      tin_length: "10.0",
      min_weight: "15.01",
      max_weight: "150.00",
      cost: 10000,
      fee: 16800,
      peer_fee: 13800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 43,
      way: "D",
      cm_length: "33.0",
      tin_length: "11.0",
      min_weight: "18.01",
      max_weight: "200.00",
      cost: 11000,
      fee: 18900,
      peer_fee: 15800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 44,
      way: "D",
      cm_length: "36.0",
      tin_length: "12.0",
      min_weight: "20.01",
      max_weight: "300.00",
      cost: 12000,
      fee: 21000,
      peer_fee: 17900,
      created_at: null,
      updated_at: null,
    },
  ],
  E: [
    {
      id: 45,
      way: "E",
      cm_length: "S (5 X 8)",
      tin_length: "S (1.65 X 2.64)",
      min_weight: "0.40",
      max_weight: "60.00",
      cost: 1500,
      fee: 3800,
      peer_fee: 2300,
      created_at: null,
      updated_at: null,
    },
    {
      id: 46,
      way: "E",
      cm_length: "M (6 X 9)",
      tin_length: "M (2 X 3)",
      min_weight: "0.60",
      max_weight: "60.00",
      cost: 2000,
      fee: 4500,
      peer_fee: 3000,
      created_at: null,
      updated_at: null,
    },
  ],
  F: [
    {
      id: 47,
      way: "F",
      cm_length: "2.5",
      tin_length: "0.8",
      min_weight: "1.00",
      max_weight: "1.00",
      cost: 800,
      fee: 2300,
      peer_fee: 1500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 48,
      way: "F",
      cm_length: "3.5",
      tin_length: "1.2",
      min_weight: "2.00",
      max_weight: "2.00",
      cost: 1500,
      fee: 3150,
      peer_fee: 2200,
      created_at: null,
      updated_at: null,
    },
    {
      id: 49,
      way: "F",
      cm_length: "6.7",
      tin_length: "2.3",
      min_weight: "3.00",
      max_weight: "3.00",
      cost: 2000,
      fee: 3900,
      peer_fee: 2900,
      created_at: null,
      updated_at: null,
    },
    {
      id: 50,
      way: "F",
      cm_length: "8.0",
      tin_length: "2.7",
      min_weight: "4.00",
      max_weight: "4.00",
      cost: 2600,
      fee: 4350,
      peer_fee: 3500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 51,
      way: "F",
      cm_length: "9.5",
      tin_length: "3.2",
      min_weight: "5.00",
      max_weight: "5.00",
      cost: 3500,
      fee: 6700,
      peer_fee: 4800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 52,
      way: "F",
      cm_length: "10.5",
      tin_length: "3.5",
      min_weight: "6.00",
      max_weight: "6.00",
      cost: 4700,
      fee: 8800,
      peer_fee: 6800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 53,
      way: "F",
      cm_length: "11.0",
      tin_length: "3.7",
      min_weight: "7.00",
      max_weight: "7.00",
      cost: 5500,
      fee: 11000,
      peer_fee: 8300,
      created_at: null,
      updated_at: null,
    },
    {
      id: 54,
      way: "F",
      cm_length: "11.5",
      tin_length: "3.8",
      min_weight: "8.00",
      max_weight: "8.00",
      cost: 7500,
      fee: 12700,
      peer_fee: 9900,
      created_at: null,
      updated_at: null,
    },
    {
      id: 55,
      way: "F",
      cm_length: "12.0",
      tin_length: "4.0",
      min_weight: "9.00",
      max_weight: "9.00",
      cost: 10000,
      fee: 16800,
      peer_fee: 13800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 56,
      way: "F",
      cm_length: "12.5",
      tin_length: "4.2",
      min_weight: "10.00",
      max_weight: "10.00",
      cost: 11000,
      fee: 18900,
      peer_fee: 15800,
      created_at: null,
      updated_at: null,
    },
  ],
  H: [
    {
      id: 62,
      way: "H",
      cm_length: "5.4",
      tin_length: "1.8",
      min_weight: "0.50",
      max_weight: "0.50",
      cost: 800,
      fee: 2300,
      peer_fee: 1500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 63,
      way: "H",
      cm_length: "6.6",
      tin_length: "2.2",
      min_weight: "1.00",
      max_weight: "1.00",
      cost: 1500,
      fee: 3150,
      peer_fee: 2200,
      created_at: null,
      updated_at: null,
    },
    {
      id: 64,
      way: "H",
      cm_length: "9.0",
      tin_length: "3.0",
      min_weight: "1.50",
      max_weight: "1.50",
      cost: 2000,
      fee: 3900,
      peer_fee: 2900,
      created_at: null,
      updated_at: null,
    },
    {
      id: 65,
      way: "H",
      cm_length: "9.9",
      tin_length: "3.3",
      min_weight: "2.00",
      max_weight: "2.00",
      cost: 2600,
      fee: 4350,
      peer_fee: 3500,
      created_at: null,
      updated_at: null,
    },
    {
      id: 66,
      way: "H",
      cm_length: "11.1",
      tin_length: "3.7",
      min_weight: "3.00",
      max_weight: "3.00",
      cost: 3500,
      fee: 6700,
      peer_fee: 4800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 67,
      way: "H",
      cm_length: "14.4",
      tin_length: "4.8",
      min_weight: "5.00",
      max_weight: "5.00",
      cost: 3500,
      fee: 6700,
      peer_fee: 4800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 68,
      way: "H",
      cm_length: "17.4",
      tin_length: "5.8",
      min_weight: "10.00",
      max_weight: "10.00",
      cost: 3500,
      fee: 6700,
      peer_fee: 4800,
      created_at: null,
      updated_at: null,
    },
    {
      id: 69,
      way: "H",
      cm_length: "21.0",
      tin_length: "7.0",
      min_weight: "20.00",
      max_weight: "20.00",
      cost: 3500,
      fee: 6700,
      peer_fee: 4800,
      created_at: null,
      updated_at: null,
    },
  ],
  G: [
    {
      id: 70,
      way: "G",
      cm_length: "3.5",
      tin_length: "1.2",
      min_weight: "0.60",
      max_weight: "0.60",
      cost: 800,
      fee: 2301,
      peer_fee: 1500,
      created_at: null,
      updated_at: "2022-08-07 23:15:39",
    },
    {
      id: 71,
      way: "G",
      cm_length: "5.0",
      tin_length: "1.7",
      min_weight: "1.50",
      max_weight: "1.50",
      cost: 1500,
      fee: 3150,
      peer_fee: 2200,
      created_at: null,
      updated_at: "2022-08-07 23:15:39",
    },
    {
      id: 72,
      way: "G",
      cm_length: "7.0",
      tin_length: "2.3",
      min_weight: "3.00",
      max_weight: "3.00",
      cost: 2000,
      fee: 3900,
      peer_fee: 2900,
      created_at: null,
      updated_at: "2022-08-07 23:15:39",
    },
  ],
  I: [
    {
      id: 73,
      way: "I",
      cm_length: "4.5",
      tin_length: "1.5",
      min_weight: "0.10",
      max_weight: "0.50",
      cost: 1000,
      fee: 2000,
      peer_fee: 1500,
      created_at: null,
      updated_at: "2025-10-17 23:15:39",
    },
  ],
  J: [
    {
      id: 74,
      way: "J",
      cm_length: "4.5",
      tin_length: "1.5",
      min_weight: "0.10",
      max_weight: "0.50",
      cost: 1000,
      fee: 2000,
      peer_fee: 1500,
      created_at: null,
      updated_at: "2025-10-17 23:15:39",
    },
  ],
};

export const goldWeightListHandler = rest.get(
  `${API_BASE_URL}gold/weight-list`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        result: "success",
        data: weightListData,
      })
    );
  }
);

export const goldWeightListHandlers = [goldWeightListHandler];
